interface ContractFamiliesPathOptions {
  txId?: string | null;
  snapshotCollectionId?: string | null;
  pipelineRunId?: string | null;
  stage?: "create_snapshots" | "categorise_review_confirm" | "summarise" | null;
}

export const buildContractFamiliesPath = (
  folderFseId?: string | null,
  txIdOrOptions?: string | null | ContractFamiliesPathOptions,
) => {
  const path = folderFseId ? `/contract-families/${encodeURIComponent(folderFseId)}` : "/contract-families";
  const options = typeof txIdOrOptions === "object" && txIdOrOptions !== null ? txIdOrOptions : { txId: txIdOrOptions };
  const searchParams = new URLSearchParams();
  if (options.txId) searchParams.set("txId", options.txId);
  if (options.snapshotCollectionId) searchParams.set("snapshotCollectionId", options.snapshotCollectionId);
  if (options.pipelineRunId) searchParams.set("pipelineRunId", options.pipelineRunId);
  if (options.stage) searchParams.set("stage", options.stage);
  if (searchParams.size === 0) {
    return path;
  }
  return `${path}?${searchParams.toString()}`;
};
